<template>
    <div class="grid reporting">
        <div class="col-12">
            <div class="card">
                <h5>Vendor Partner Download</h5>
                <p>Access comprehensive vendor data and analytics for reporting and analysis purposes.</p>

                <div class="p-grid p-fluid">
                    <div class="p-col-12 p-md-4">
                        <div class="card">
                            <h6>General Vendor Information</h6>
                            <p>Download all vendors' profile, agreements, and business Information.</p>
                                                        <div class="download-buttons">
                                <Button
                                    label="Excel"
                                    icon="pi pi-file-excel"
                                    class="p-button p-button-outlined p-button-success p-button-sm"
                                    @click="downloadGeneralVendorInfo('excel')"
                                    :loading="loadingStates['0_excel']"
                                />
                                <Button
                                    label="JSON"
                                    icon="pi pi-file"
                                    class="p-button p-button-outlined p-button-info p-button-sm"
                                    @click="downloadGeneralVendorInfo('json')"
                                    :loading="loadingStates['0_json']"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="p-col-12 p-md-4">
                        <div class="card">
                            <h6>Talent Answerbank</h6>
                            <p>Download all vendors' Talent-related Answerbank data. Each Answerbank section will be reported in a separate tab.</p>
                            <div class="dropdown-container">
                                <Dropdown
                                    v-model="selectedTalentCategory"
                                    :options="talentCategories"
                                    optionLabel="label"
                                    optionValue="id"
                                    placeholder="Select Talent Category"
                                    class="technology-dropdown"
                                />
                                <div class="download-buttons">
                                    <Button
                                        label="Excel"
                                        icon="pi pi-file-excel"
                                        class="p-button p-button-outlined p-button-success p-button-sm"
                                        @click="downloadTalentAnswerbank('excel')"
                                        :loading="loadingStates[selectedTalentCategory + '_excel']"
                                    />
                                    <Button
                                        label="JSON"
                                        icon="pi pi-file"
                                        class="p-button p-button-outlined p-button-info p-button-sm"
                                        @click="downloadTalentAnswerbank('json')"
                                        :loading="loadingStates[selectedTalentCategory + '_json']"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="p-col-12 p-md-4">
                        <div class="card">
                            <h6>Technology Answerbank</h6>
                            <p>Download all vendors' selected Technology-related Answerbank data. Each Answerbank section will be reported in a separate tab.</p>
                            <div class="dropdown-container">
                                <Dropdown
                                    v-model="selectedTechnologyCategory"
                                    :options="technologyCategories"
                                    optionLabel="full_name"
                                    optionValue="id"
                                    placeholder="Select Technology Category"
                                    class="technology-dropdown"
                                />
                                                                <div class="download-buttons">
                                    <Button
                                        label="Excel"
                                        icon="pi pi-file-excel"
                                        class="p-button p-button-outlined p-button-success p-button-sm"
                                        @click="downloadTechnologyAnswerbank('excel')"
                                        :loading="loadingStates[selectedTechnologyCategory + '_excel']"
                                    />
                                    <Button
                                        label="JSON"
                                        icon="pi pi-file"
                                        class="p-button p-button-outlined p-button-info p-button-sm"
                                        @click="downloadTechnologyAnswerbank('json')"
                                        :loading="loadingStates[selectedTechnologyCategory + '_json']"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="p-col-12 p-md-4">
                        <div class="card">
                            <h6>Transformation Answerbank</h6>
                            <p>Download transformation-related answerbank data with category tabs.</p>
                            <div class="dropdown-container">
                                <Dropdown
                                    v-model="selectedTransformationCategory"
                                    :options="transformationCategories"
                                    optionLabel="full_name"
                                    optionValue="id"
                                    placeholder="Select Transformation Category"
                                    class="transformation-dropdown"
                                />
                                                                <div class="download-buttons">
                                    <Button
                                        label="Excel"
                                        icon="pi pi-file-excel"
                                        class="p-button p-button-outlined p-button-success p-button-sm"
                                        @click="downloadTransformationAnswerbank('excel')"
                                        :loading="loadingStates[selectedTransformationCategory + '_excel']"
                                    />
                                    <Button
                                        label="JSON"
                                        icon="pi pi-file"
                                        class="p-button p-button-outlined p-button-info p-button-sm"
                                        @click="downloadTransformationAnswerbank('json')"
                                        :loading="loadingStates[selectedTransformationCategory + '_json']"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="p-col-12 p-md-4">
                        <div class="card">
                            <h6>Vendor Telemetry</h6>
                            <p>Download all vendors' opportunities</p>
                                                        <div class="download-buttons">
                                <Button
                                    label="Excel"
                                    icon="pi pi-file-excel"
                                    class="p-button p-button-outlined p-button-success p-button-sm"
                                    @click="downloadVendorTelemetry('excel')"
                                    :loading="loadingStates['100_excel']"
                                />
                                <Button
                                    label="JSON"
                                    icon="pi pi-file"
                                    class="p-button p-button-outlined p-button-info p-button-sm"
                                    @click="downloadVendorTelemetry('json')"
                                    :loading="loadingStates['100_json']"
                                />
                            </div>
                        </div>

                    </div>

                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import VendorDataExportService from '../service/VendorDataExportService';

const vendorDataService = new VendorDataExportService();

export default {
    name: 'PartnerVendorDownload',
    components: {
        Button,
        Dropdown
    },
        data() {
            return {
                loadingStates: {},
                directoryData: null,
                selectedTransformationCategory: null,
                selectedTechnologyCategory: null,
                selectedTalentCategory: null,
                transformationCategories: [],
                technologyCategories: [],
                talentCategories: []
            };
        },
    async created() {
        let directoryDataResponse = await vendorDataService.directoryTree();
        this.directoryData = directoryDataResponse.data;
        // Filter categories
        this.transformationCategories = this.directoryData.filter(item =>
            item.name.startsWith('transformation')
        );
        this.technologyCategories = this.directoryData.filter(item =>
            item.name.startsWith('technology')
        );
        // Talent has two flavours: legacy BPO (kept for compatibility) and the
        // newer Software Engineering question set. Q-set ids differ by env, so
        // we match on the name/full_name strings instead of hardcoding ids.
        this.talentCategories = this.directoryData
            .filter(item => {
                const haystack = `${item.name || ''} ${item.full_name || ''}`.toLowerCase();
                const isTalent = haystack.includes('talent');
                const isSE = /software\s*engineering/.test(haystack);
                return isTalent || isSE;
            })
            .map(item => ({
                id: item.id,
                label: /software\s*engineering/i.test(`${item.name || ''} ${item.full_name || ''}`)
                    ? 'Software Engineering'
                    : 'BPO',
            }));
    },
    methods: {
        /**
         * Generic download method for any question set
         * @param {number} questionSetId - The question set ID
         * @param {string} displayName - Display name for toast messages
         * @param {string} format - 'excel' or 'json'
         */
        async downloadVendorData(questionSetId, displayName, format = 'excel') {
            const loadingKey = `${questionSetId}_${format}`;
            this.loadingStates[loadingKey] = true;

            try {
                const response = await vendorDataService.downloadByQuestionSetId(questionSetId, format);
                const data = response.data;

                // Check if API returned "No data found" message
                if (data.message && data.message.includes("No data found")) {
                    this.$toast.add({
                        severity: 'warn',
                        summary: 'No Data Available',
                        detail: `No data found for ${displayName}. Please try a different category.`,
                        life: 4000
                    });
                    return;
                }

                // Check if response has downloadUrl
                if (data && data.downloadUrl) {
                    if (format === 'json') {
                        const fileRes = await fetch(data.downloadUrl);
                        const text = await fileRes.text();
                        const blob = new Blob([text], { type: 'application/octet-stream' });
                        const blobUrl = URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = blobUrl;
                        a.download = data.fileName || 'export.json';
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(blobUrl);
                    } else {
                        window.open(data.downloadUrl, '_blank');
                    }

                    // Create success message based on question set type
                    let detailMessage = `${data.fileName} has been downloaded successfully. ${data.totalVendors} vendors exported.`;
                    if (data.totalCategories) {
                        detailMessage = `${data.fileName} has been downloaded successfully. ${data.totalVendors} vendors, ${data.totalCategories} categories exported.`;
                    }

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Download Complete',
                        detail: detailMessage,
                        life: 5000
                    });
                } else {
                    console.error('No downloadUrl in response:', data);
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Download Failed',
                        detail: 'No download URL received from server',
                        life: 3000
                    });
                }
            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Download Failed',
                    detail: `Failed to download ${displayName}`,
                    life: 3000
                });
            } finally {
                this.loadingStates[loadingKey] = false;
            }
        },

        // Convenience methods for each download type
        async downloadGeneralVendorInfo(format) {
            await this.downloadVendorData(0, 'General Vendor Information', format);
        },

        async downloadTalentAnswerbank(format) {
            if (!this.selectedTalentCategory) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Selection Required',
                    detail: 'Please select a talent category first',
                    life: 3000
                });
                return;
            }
            await this.downloadVendorData(this.selectedTalentCategory, 'Talent Answerbank', format);
        },

        async downloadTechnologyAnswerbank(format) {
            if (!this.selectedTechnologyCategory) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Selection Required',
                    detail: 'Please select a technology category first',
                    life: 3000
                });
                return;
            }
            await this.downloadVendorData(this.selectedTechnologyCategory, 'Technology Answerbank', format);
        },

        async downloadTransformationAnswerbank(format) {
            if (!this.selectedTransformationCategory) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Selection Required',
                    detail: 'Please select a transformation category first',
                    life: 3000
                });
                return;
            }
            await this.downloadVendorData(this.selectedTransformationCategory, 'Transformation Answerbank', format);
        },

        async downloadVendorTelemetry(format) {
            await this.downloadVendorData(100, 'Vendor Telemetry', format);
        }
    }
};
</script>

<style scoped>
.card {
    padding: 1.5rem;
    margin-bottom: 1rem;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.card h6 {
    margin-top: 0;
    margin-bottom: 0.5rem;
    color: #495057;
}

.card p {
    margin-bottom: 1rem;
    color: #6c757d;
    flex-grow: 1;
}

.download-buttons {
    display: flex;
    gap: 0.5rem;
    margin-top: auto;
}

.download-buttons .p-button {
    flex: 1;
    min-width: 0;
    justify-content: center;
}

.download-buttons .p-button ::v-deep(.p-button-label) {
    flex: none;
}

.download-buttons .p-button:disabled {
    opacity: 0.7 !important;
}

.dropdown-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: auto;
}

.technology-dropdown,
.transformation-dropdown {
    width: 100%;
}

/* Ensure all cards in a row have the same height */
.p-grid .p-col-12 {
    display: flex;
}

.p-grid .p-col-12 .card {
    width: 100%;
}
</style>
